<template>
  <div :class="width" class="p-1">
    <div class="sm:h-72 h-48 shadow">
      <router-link
        :to="{
          path: '/celebs/',
          name: 'CelebDetails',
          params: {
            id: data.id
          }
        }"
      >
        <img
          v-if="data['profile_path']"
          :src="imageUrl(data['profile_path'])"
          :alt="data['name']"
          class="w-full h-full"
        />
        <img
          v-else
          src="@/assets/images/avatar-icon.png"
          :alt="data['name']"
          class="w-full h-full"
        />
      </router-link>
    </div>
    <div class="p-2 text-white h-20 bg-secondary">
      <p class="xs:text-sm text-xs font-semibold mb-2">
        <router-link
          :to="{
            path: '/celebs/',
            name: 'CelebDetails',
            params: {
              id: data.id
            }
          }"
        >
          {{ data["name"] }}
        </router-link>
      </p>
      <p class="text-sm text-gray-500">
        {{
          data["known_for_department"] === "Acting"
            ? data["gender"] === 1
              ? "Actress"
              : "Actor"
            : data["known_for_department"]
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-celebs",
  props: {
    data: Object,
    width: {
      type: String,
      default: "w-48"
    }
  }
};
</script>
